import React from 'react';
import { Link } from 'react-router-dom';

function ResultImg(props){
    return(
        <>     
                 <Link to={`/search/${props.id}`} className='linkrandom'>

                <div className='resdiv'>
                <img src={props.imgv} className='imgresult'/>
                 <h5>{props.name}</h5>
                </div>
                 </Link>
        </>
    )
}

export default ResultImg;